import React, { useState } from 'react'
import '../../components/kyc/kycStyle.css'
import './TitleDeed.css'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import { API_ERROR_MESSAGE, PRICELIST } from '../../utils/Constants'
import { RESTRICTED_REPORT } from '../../utils/Constants'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import { getTitleDeedAccess, requestTitleDeed } from '../../api/titleDeed'
import { useMutation, useQuery } from 'react-query'
import { Spinner } from 'react-bootstrap'

type TitleDeedProps = {
  setShow: (value: boolean) => void
  setIsError: (arg0: boolean) => void
  setErrorMessage: (value: string) => void
  KYCAccess: boolean
}

const TitleDeed: React.FC<TitleDeedProps> = ({
  setShow,
  setIsError,
  setErrorMessage,
  KYCAccess,
}) => {
  const [hfAddress] = useState(
    (document.getElementById('hfAddress') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? '15 suikerbossie street' : ''),
  )
  const [hfAllotment] = useState(
    (document.getElementById('hfAllotment') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? 'Allotment' : ''),
  )
  const [hfErfNo] = useState(
    (document.getElementById('hfErfNo') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? '1234' : ''),
  )
  const [hfTitleDeed] = useState(
    (document.getElementById('hfTitleDeed') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? 'The Title Deed' : ''),
  )
  const [hfCMAID] = useState(
    (document.getElementById('hfCMAID') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? '3035217' : ''),
  )
  const [hfSchemeNo] = useState(
    (document.getElementById('hfSchemeNo') as HTMLInputElement)?.value,
  )
  const [hfSectionNo] = useState(
    (document.getElementById('hfSectionNo') as HTMLInputElement)?.value,
  )

  //useQuery call for debit order access here
  const { data: titleDeedAccess, isLoading: isLoadingAccess } = useQuery(
    'title-deed-access',
    getTitleDeedAccess,
    {
      onError: () => {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      },
    },
  )

  console.log('title', titleDeedAccess)

  //useMutation call for proceed event here
  const { mutate: proceed, isLoading: isLoadingProceed } = useMutation(
    'title-deed-proceed',
    requestTitleDeed,
    {
      onSuccess: () => {
        alert('An email with your report will be sent to you shortly')
      },
      onError: () => {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      },
    },
  )

  const handleSearch = async () => {
    await proceed({
      cmaid: hfCMAID,
      schemeNo: hfSchemeNo,
      sectionNo: hfSectionNo,
    })
  }

  if (!titleDeedAccess?.agentDOPerm) {
    return (
      <ScreenLayout
        headerText="Title Deed Document"
        subHeaderText="You are requesting the Title Deed Document for"
        price={PRICELIST.TITLE_DEED}
      >
        {KYCAccess !== true && <p className="lbl-red">{RESTRICTED_REPORT}</p>}
        <p>
          No arrangement has been made to include Title Deed charges on your
          account.
        </p>
        <p>
          To arrange this please have the{' '}
          <a
            href="https://fluenty.cmainfo.co.za/Docs/cma-info-debit-order-addendum.pdf"
            target="_blank"
          >
            Addendum to contract{' '}
          </a>{' '}
          completed by your principal.
        </p>
      </ScreenLayout>
    )
  }

  return (
    <ScreenLayout
      headerText="Title Deed Document"
      subHeaderText="You are requesting the Title Deed Document for"
      price={PRICELIST.TITLE_DEED}
    >
      {isLoadingProceed && (
        <>
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        </>
      )}
      {KYCAccess !== true && <p className="lbl-red">{RESTRICTED_REPORT}</p>}

      <table style={{ width: '600px', marginTop: '20px' }}>
        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Adrress:</span>
          </td>
          <td className="labelMargin">
            <span className="">{hfAddress}</span>
          </td>
        </tr>

        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Erf No:</span>
          </td>
          <td className="labelMargin">
            <span className="">{hfErfNo}</span>
          </td>
        </tr>

        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Allotment:</span>
          </td>
          <td className="labelMargin">
            <span className="">{hfAllotment}</span>
          </td>
        </tr>

        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Title Deed:</span>
          </td>
          <td className="labelMargin">
            <span className="">{hfTitleDeed}</span>
          </td>
        </tr>
      </table>

      <div className="spacer" />
      <p>
        The cost will be R99.00 + R14.85 VAT for a total of R113.85 for the
        title deed which will be billed to your account
      </p>
      <p>
        <b>Please note</b> that the turnaround for the title deed request is
        usually two to three days. Unfortunately it can also be two to three
        months if the document is not readily available.
        <br />
        If the Deeds Office is unable to find the Title Deed within three
        months, please advise and we will refund any payments made.
      </p>
      <FooterButtons
        handleSearch={handleSearch}
        searchChildren="Proceed"
        setShow={setShow}
      />
    </ScreenLayout>
  )
}
export default TitleDeed
